import { push } from 'connected-react-router';
import { actions } from 'react-redux-form';
import moment from 'moment';
export const SET_MODAL_OPEN = 'SET_MODAL_OPEN';

export const openModal = (name, data) => dispatch => setModalState(dispatch, name, data, true);

export const openInModalOrPage = (formPath, itemId, formData, altId, altId2, altId3) => async (dispatch, getState) => {
    if (formPath.formName) {
        dispatch(actions.change(formPath.formName, formData));
    }
    if (getState().settings.openInModals) {
        dispatch(openModal(formPath.modalName, formPath.modalData(itemId, altId, altId2, altId3)));
    } else {
        dispatch(push(formPath.makePath(itemId, altId, altId2, altId3)));
    }
};

export const FORM_PATHS = {
    ExpiredTokenModal: {
        modalName: 'ExpiredTokenModal',
        modalData: () => null
    },
    ViewDemoModal: {
        modalName: 'ViewDemoModal',
        modalData: demoId => ({ demoId }),
        makePath: demoId => `/demo/view/${demoId}`
    },
    EditVisitActionModal: {
        modalName: 'EditVisitActionModal',
        modalData: (visitActionId, companyId, parentCommunicationId) => ({
            visitActionId,
            companyId,
            parentCommunicationId
        }),
        makePath: (visitActionId, companyId, parentCommunicationId) =>
            `/task/edit/${visitActionId}/${parentCommunicationId}/${companyId}`
    },
    EditDayModal: {
        modalName: 'EditDayModal',
        modalData: (eventId, startDate, eventType) => ({
            eventId,
            startDate,
            eventType
        }),
        makePath: (eventId, startDate, eventType) => `/day/edit/${eventType}/${eventId}/${moment(startDate).format()}`
    },
    EditCommunicationModal: {
        modalName: 'EditCommunicationModal',
        modalData: (communicationId, companyId) => ({
            communicationId,
            companyId
        }),
        makePath: (communicationId, companyId) => `/communication/edit/${companyId}/${communicationId}`
    },
    EditMeetingModal: {
        modalName: 'EditMeetingModal',
        modalData: (meetingId, companyId) => ({
            meetingId,
            companyId
        }),
        makePath: (meetingId, companyId) => `/meeting/edit/${companyId}/${meetingId}`
    },
    CancelCommunicationModal: {
        modalName: 'CancelCommunicationModal',
        modalData: (communicationId, companyId) => ({
            communicationId,
            companyId
        }),
        makePath: (communicationId, companyId) => `/communication/cancel/${companyId}/${communicationId}`
    },
    CancelMeetingModal: {
        modalName: 'CancelMeetingModal',
        modalData: (communicationId, companyId) => ({
            communicationId,
            companyId
        }),
        makePath: (communicationId, companyId) => `/communication/cancel/${companyId}/${communicationId}`
    },
    CompleteCommunicationModal: {
        modalName: 'CompleteCommunicationModal',
        modalData: (communicationId, companyId) => ({
            communicationId,
            companyId
        }),
        makePath: (communicationId, companyId) => `/communication/complete/${companyId}/${communicationId}`
    },
    CompleteMeetingModal: {
        modalName: 'CompleteMeetingModal',
        modalData: (meetingId, companyId) => ({
            meetingId,
            companyId
        }),
        makePath: (meetingId, companyId) => `/meeting/complete/${companyId}/${meetingId}`
    },
    EditAgreementTerm: {
        modalName: 'EditAgreementTermModal',
        modalData: id => ({ id }),
        formName: 'agreementTermForm',
        makePath: termId => `/agreement/create/term/edit/${termId}`
    },
    EditPerson: {
        modalName: 'PersonEditModal',
        modalData: (personId, companyId) => ({ personId, companyId }),
        makePath: (personId, companyId) => `/people/edit/${companyId}/${personId}`
    },
    CreateLead: {
        modalName: 'CreateLeadModal',
        modalData: leadId => ({ leadId }),
        makePath: leadId => `/lead/edit/${leadId}`
    },
    EditAddress: {
        modalName: 'EditAddressModal',
        modalData: (addressId, companyId) => ({ addressId, companyId }),
        makePath: (addressId, companyId) => `/address/edit/${companyId}/${addressId}`
    } /*
    RejectAgreementModal: {
        modalName: 'RejectAgreementModal',
        modalData: agreementId => ({ agreementId }),
        makePath: agreementId => `/agreement/edit/${agreementId}`
    },*/,
    RequestSupport: {
        modalName: 'RequestSupportModal',
        modalData: () => ({}),
        makePath: () => `/support/request`
    }
};

export const closeModal = (formPath, data = {}) => dispatch => setModalState(dispatch, formPath, data, false);

const setModalState = (dispatch, name, data, isOpen) => dispatch({ type: SET_MODAL_OPEN, name, isOpen, data });
